// extracted by mini-css-extract-plugin
module.exports = {"Box":"ProfileView_Box__aDHBx"};